// extracted by mini-css-extract-plugin
export default {"Button":"w5TpVkhckykZsPEPUXE6","Button_layout_in_slider":"i_hmNa1aqh9HrfN3LCGU"};